import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SuperAdminMemberManagementService } from '../super-admin-member-management.service';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { DumbCompanyDetails } from '../DTOs/dumb-company';

@Component({
  selector: 'app-edit-company-directory-info-modal',
  templateUrl: './edit-company-directory-info-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EditCompanyDirectoryInfoModalComponent {

    company: DumbCompanyDetails;
    memberId: string;

    constructor(private activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private membershipService: SuperAdminMemberManagementService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService) { }

    descriptionCtrl = new FormControl("description");
    logo: File = null;
    imageTypes = ['image/jpeg', 'image/png', 'image/webp'];
    websiteCtrl = new FormControl("website");

    manageCompanyDirectoryInfoForm: FormGroup = new FormGroup({
        description: this.descriptionCtrl,
        website: this.websiteCtrl,
    });

    description() { return this.manageCompanyDirectoryInfoForm.get('description').value }
    website() { return this.manageCompanyDirectoryInfoForm.get('website').value }

    ngOnInit() {
        this.resetManageCompanyInfoForm();
    }

    private resetManageCompanyInfoForm(): void {
        this.manageCompanyDirectoryInfoForm.reset();
        this.manageCompanyDirectoryInfoForm.patchValue({
            description: this.company.description,
            website: this.company.website,
        });
        this.logo = null;
    }

    save() {
        for (var i in this.manageCompanyDirectoryInfoForm.controls) {
            this.manageCompanyDirectoryInfoForm.controls[i].markAsTouched();
        }
        if (!this.manageCompanyDirectoryInfoForm.valid) {
            return false;
        }
        if (this.logo != null) {
            return this.saveLogoAndDetails();
        }
        else {
            return this.saveCompanyDirectoryDetails(null);
        }
    }

    saveLogoAndDetails() {
        this.uploadLogoFile()
            .subscribe({
                next: (data) => {
                    this.saveCompanyDirectoryDetails(data);
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                }
            });
    }

    uploadLogoFile() {
        const uploadData = new FormData();
        uploadData.append('logo', this.logo, this.logo.name);
        return this.membershipService.uploadLogoFile(uploadData);
    }

    saveCompanyDirectoryDetails(logoId) {
        this.company.description = this.description();
        this.company.newLogoId = logoId;
        this.company.website = this.website();

        this.blockUI.start();
        this.membershipService.UpdateCompanyDirectoryDetails(this.company, this.memberId)
            .subscribe({
                next: (data) => {
                    this.blockUI.stop();
                    this.activeModal.close(data);
                },
                error: (err) => {
                    console.log(err)
                    this.notificationService.error(err.message);
                    this.blockUI.stop();
                },
            });
        return true;
    }
    dismiss(): void {
        this.activeModal.dismiss();
    }
    updateLogoImage(e) {
        var files = e.target.files;
        if (!this.imageTypes.includes(files.item(0).type)) {
            this.notificationService.error("File is not a recognized image type.")
            e.target.value = null;
            return;
        }
        this.logo = files[0];
    }
}
